import React, { useEffect } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import MainLayout from './components/Layout/MainLayout';
import Home from './pages/Home';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import BookList from './pages/books/BookList';
import BookDetail from './pages/books/BookDetail';
import Reader from './pages/reader/Reader';
import Profile from './pages/user/Profile';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminBooks from './pages/admin/AdminBooks';
import AdminImport from './pages/admin/AdminImport';
import AdminCategories from './pages/admin/AdminCategories';
import BookshelfDetail from './pages/bookshelf/BookshelfDetail';
import api from './utils/api';
import './index.css';

// 恢复登录状态的组件
const AuthRestore: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      // 设置请求头
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      
      // 获取当前用户信息
      api.get('/auth/me')
        .then(response => {
          dispatch({
            type: 'LOGIN_SUCCESS',
            payload: {
              token,
              user: response.data
            }
          });
        })
        .catch(error => {
          console.error('恢复登录状态失败:', error);
          localStorage.removeItem('token');
          delete api.defaults.headers.common['Authorization'];
          dispatch({ type: 'LOGOUT' });
        });
    }
  }, [dispatch]);

  return <>{children}</>;
};

function App() {
  return (
    <BrowserRouter>
      <AuthRestore>
        <Switch>
          {/* Reader 页面不经过 MainLayout（无 header/footer） */}
          <Route path="/read/:bookId" component={Reader} />
          <Route path="/reader/:format" component={Reader} />
          {/* 其他页面经过 MainLayout */}
          <MainLayout>
            <Route path="/" exact component={Home} />
            <Route path="/login" component={Login} />
            <Route path="/register" component={Register} />
            <Route path="/books" component={BookList} />
            <Route path="/book/:id" component={BookDetail} />
            <Route path="/bookshelf/:id" component={BookshelfDetail} />
            <Route path="/profile/:id" component={Profile} />
            <Route path="/admin" exact component={AdminDashboard} />
            <Route path="/admin/books" component={AdminBooks} />
            <Route path="/admin/import" component={AdminImport} />
            <Route path="/admin/categories" component={AdminCategories} />
          </MainLayout>
        </Switch>
      </AuthRestore>
    </BrowserRouter>
  );
}

export default App;
